function initializeViewToggle() {
    const viewSelector = document.getElementById('view-mode-selector');
    const productContainer = document.querySelector('.product-grid-container');

    if (!viewSelector || !productContainer) return;

    const storedView = sessionStorage.getItem('viewPreference');

    if (storedView) {
        if (storedView === 'list') {
            productContainer.classList.add('product-list-container');
            viewSelector.value = 'list';
        } else {
            productContainer.classList.remove('product-list-container');
            productContainer.classList.add('product-grid-container');
            viewSelector.value = 'grid';
        }
    } else {
        viewSelector.value = 'grid';
    }

    viewSelector.addEventListener('change', function() {
        const selectedView = this.value;
        if (selectedView === 'list') {
            productContainer.classList.add('product-list-container');
        } else {
            productContainer.classList.remove('product-list-container');
            productContainer.classList.add('product-grid-container');
        }
        sessionStorage.setItem('viewPreference', selectedView);
    });
}

const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
            initializeViewToggle();
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    initializeViewToggle();

    const productContainer = document.querySelector('.product-grid-container');
    if (productContainer) {
        observer.observe(productContainer, { childList: true });
    }

    // const searchButtonFilters = document.querySelectorAll('.search-button-filter > div');
    // if (searchButtonFilters.length) {
    //     searchButtonFilters.forEach(button => {
    //         button.addEventListener('click', () => {
    //             console.log('clicked');
    //             const cards = document.querySelectorAll('.grid__item');
    //             cards.forEach(card => {
    //                 const cardStyle = card.querySelector('.card-wrapper');
    //                 if (cardStyle.classList.contains('product-card-wrapper')) {
    //                     card.style.display = 'none';
    //                 }
    //             });
                
    //             // Refresh products and find the ones that are not hidden
    //             const refreshedCards = document.querySelectorAll('.grid__item');
    //             refreshedCards.forEach(card => {
    //                 const cardStyle = card.querySelector('.card-wrapper');
    //                 if (cardStyle.classList.contains('product-card-wrapper')) {
    //                     card.style.display = 'block';
    //                 }
    //             });
    //         });
    //     });
    // }
});
